import { faArrowUpRightFromSquare, faAward, faCalendarAlt, faClock, faFileAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import moment from 'moment';
import { Component } from 'react';
import { Card, Col, Container, Form, Image, Modal, Row, Spinner } from 'react-bootstrap';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import { GET, POST } from '../../api';
import GeneralCard from '../../helpers/GeneralCard';
import { AmericanGreen, Argent, Black, Blueberry, BlueCrayola, CerisePink, ColonialWhite, Concrete, CyanProcess, GoldenPoppy, LightSilver, PaleOyster, Purple, RedLustre, SpanishGray, VividMalachite, White, WhiteMarble } from '../../helpers/brand_colors_helper';
import { changeColorOpacity, makeURL, trimThisDown } from '../../helpers/general_helpers';
import { withParams } from '../../helpers/params_helper';
import { getRegionalStorageURL } from '../../helpers/regional_storage_url_helper';
import { t } from '../../helpers/translation_helper';
import Header from '../_partials/Header/_Header';
import NavBar from '../_partials/NavBar/_NavBar';
import Paginate from '../_partials/Paginate/_Paginate';
import './subject.css';
import GetIcon from '../../helpers/icon_helper';
import ExamsCard from '../../helpers/ExamsCard';
import { Chance } from 'chance';
import AcademicActivityReflection from '../Dashboard/AcademicActivityReflection';
const chance = new Chance();

// API URL
const apiURL = process.env.REACT_APP_API_URL;
const portalURL = process.env.REACT_APP_PORTAL_URL;
/**
 * Subject Component
 */
class Subject extends Component {
  // State
  state = {
    searchLesson: '',
    getAcademicClassmainSubjectData: null,
    todaysLessons: null,
    lessons: null,
    limit: 12,
    totalRecords: 0,
    // Paginate
    examsData: {
      data: [],
      limit: 30,
      offset: 0,
      totalRecords: 0,
      lastPage: 0,
    },
    homeworkData: {
      data: [],
      limit: 30,
      offset: 0,
      totalRecords: 0,
      lastPage: 0,
    },
    calendarList: [],
    examModalInfo: {
      show: false,
      data: null,
      toggle: (data = null) => this.setState({ examModalInfo: { ...this.state.examModalInfo, show: !this.state.examModalInfo.show, data } })
    },
    activitiesData: {
      refreshing: false,
      finished: false,
      limit: 12,
      offset: 0,
      data: [],
      totalRecords: 0,
    },
    academicActivityReflectionModal: {
      show: false,
      modalTitle: 'Assignment',
      data: null,
      closeModal: () => this.setState({ academicActivityReflectionModal: { ...this.state.academicActivityReflectionModal, show: false } }),
      toggleModal: (modalTitle = null, data = null) => this.setState({
        academicActivityReflectionModal: { ...this.state.academicActivityReflectionModal, show: !this.state.academicActivityReflectionModal.show, modalTitle, data }
      }),
      showModal: () => this.setState({ academicActivityReflectionModal: { ...this.state.academicActivityReflectionModal, show: true } }),
    },
  };

  /**
   * Component Did Mount
   */
  componentDidMount() {
    this.getAcademicClassmainSubject();
    this.getExams();
    this.getHomeworks();
    this.getLessons();
    this.getCalendar()
    this.getUserTimeline()
    // this.getTodaysLessons();
  }

  getUserTimeline = () => {

    const { authData, selectedChild } = this.props;
    const { class_id, child_id } = selectedChild;

    if (this.state.activitiesData.refreshing) {
      return false
    }
    if (this.state.activitiesData.finished) {
      return false
    }

    this.setState({ activitiesData: { ...this.state.activitiesData, refreshing: true } }, () => {

      if (this.getUserTimelineRequest) {
        this.getUserTimelineRequest.abort()
      }
      this.getUserTimelineRequest = new AbortController();

      let userTimelineDataLen = this.state.activitiesData.data.length

      let fData = new FormData()
      fData.append('selectedTimelineTypes', JSON.stringify([{ active: true, ut_type: "Academic Activity" }]))
      fData.append('offset', 0)
      fData.append('limit', 50)
      fData.append('user_id', this.props.authData.loginData.user_id)
      fData.append('child_id', child_id)
      fData.append('class_id', class_id)
      fData.append('center_id', this.props.authData.centerData.center_id)
      fData.append('center_timezone', this.props.authData.centerData.center_timezone)
      fData.append('ut_id', 0)
      fData.append('acs_id', this.props.params.acs_id)
      fData.append('activeFilterDateFrom', moment(new Date(moment().subtract(24, 'month'))).format('YYYY-MM-DD') + ' 00:00:00')
      fData.append('activeFilterDateTo', moment(new Date()).format('YYYY-MM-DD') + ' 23:59:59')

      POST('user-timeline', fData, {
        params: {
          auth_key: this.props.authData.loginData.auth_key,
        },
        signal: this.getUserTimelineRequest.signal,
      })
        .then((res) => {
          if (res) {
            let resData = res.data
            if (resData.length <= 0) {
              this.setState({ activitiesData: { ...this.state.activitiesData, refreshing: false, finished: true, offset: this.state.activitiesData.offset + this.state.activitiesData.limit } })
              return
            }
            this.setState({ activitiesData: { ...this.state.activitiesData, data: this.state.activitiesData.data.concat(resData), refreshing: false, finished: false, offset: this.state.activitiesData.offset + this.state.activitiesData.limit } })
          }
        })

    })

  }

  renderActivities = (allData) => {
    const { getUserTimelineData, academicActivityReflectionModal } = this.state;
    let cardImage = (allData.academic_activities.aa_image) ? getRegionalStorageURL() + this.props.authData.centerData.center_uuid + '/academic_activities/' + allData.academic_activities.aa_image : require('../../assets/images/noimage.png')

    return <div className='d-flex flex-column justify-content-between' key={this.props.key} style={{ width: 'calc(' + '33.33% - 20px)', backgroundColor: White, borderRadius: 20, margin: 10, position: 'relative', padding: 0, fontSize: 12, border: 'solid 1px ' + Concrete }}>
      <div style={{ padding: '1rem', height: '100%' }} className='d-flex flex-column justify-content-between'>
        <div>
          <div className='d-flex flex-row justify-content-between align-items-start mb-2'>
            <div style={{ flex: 1, fontWeight: '600' }}> {allData.ut_title}</div>
            <div style={{ flex: 1 }} className='d-flex flex-row justify-content-end flex-wrap'>
              {allData.academic_classmain_subject && allData.academic_classmain_subject.map((acs_v, acs_i) => {
                return <div key={acs_i} style={{ backgroundColor: CyanProcess, color: White, padding: '2px 4px', borderRadius: 5, fontSize: 11 }} className='d-flex flex-row align-items-center ms-2 mb-1'>
                  {acs_v.acs_name}
                </div>
              })}
            </div>
          </div>
          <Image src={cardImage} style={{ objectFit: 'cover', width: '100%', height: '8rem', backgroundColor: White, borderRadius: '1rem' }} />
          <div className='d-flex flex-row justify-content-between align-items-start mt-2 mb-1' style={{ fontSize: 11 }}>
            <div className='d-flex flex-row' style={{ fontSize: 10, color: SpanishGray, }}>
              <div className='me-2'>
                <div style={{ color: LightSilver, fontSize: 8 }}>From</div>
                <div>{moment(allData.start_datetime).format('DD-MM-YYYY')}</div>
                <div>{moment(allData.start_datetime).format('HH:mm A')}</div>
              </div>
              <div>
                <div style={{ color: LightSilver, fontSize: 8 }}>To</div>
                <div>{moment(allData.end_datetime).format('DD-MM-YYYY')}</div>
                <div>{moment(allData.end_datetime).format('HH:mm A')}</div>
              </div>
            </div>
            <div style={{ backgroundColor: WhiteMarble, color: Black, borderRadius: 5, fontSize: 11, padding: '1px 2px' }} className='d-flex flex-row align-items-center'>
              <GetIcon icon={'LuCalendar1'} className={'me-1'} style={{ fontSize: 10 }} />
              {moment(allData.created_on).format('DD-MM-YYYY')}
            </div>
          </div>
          {(allData.ut_description && allData.ut_description != 'null') && <div style={{ color: SpanishGray }}>{trimThisDown(allData.ut_description, 60)}</div>}
        </div>
        <div className='d-flex flex-row justify-content-between align-items-end mt-1'>
          <div style={{ backgroundColor: CerisePink, color: White, borderRadius: 5, fontSize: 11, padding: '2px 3px' }} className='d-flex flex-row align-items-center'>
            <div>Reflections</div>
            <div className='text-center mx-1' style={{ minHeight: 10, minWidth: 15, borderRadius: 10, backgroundColor: White, color: Black, fontSize: 10 }}>{allData.academic_activity_reflections_new}</div>
          </div>
          <div className='d-flex flex-row align-items-center cursor-pointer' style={{ color: BlueCrayola, textDecoration: 'underline' }} onClick={() => academicActivityReflectionModal.toggleModal(allData.ut_title, allData)}>
            <div className='me-1'>More Details</div>
            <GetIcon icon="LuExternalLink" />
          </div>
        </div>
      </div>
    </div>
  }

  getAcademicClassmainSubject = async () => {
    try {
      const res = await GET('dashboard/get-academic-classmain-subject', {
        params: { acs_id: this.props.params.acs_id },
      });
      this.setState({
        getAcademicClassmainSubjectData: res.data,
      });
    } catch (err) {
      toast.error('Something went wrong while fetching getAcademicClassmainSubject!');
      // console.log(err);
    }
  };

  /**
     * Get Calendar
     */
  getCalendar = async () => {
    this.setState({
      calendarList: null,
    })
    const { auth_key, center_id } = this.props.authData.loginData
    const { class_id } = this.props.selectedChild

    let request_params = {
      center_id,
      class_id,
      auth_key,
      date: moment().format('YYYY-MM-DD'),
    }

    try {
      const res = await GET('center-calendar/get-center-calendar-day',
        { params: request_params }
      )

      this.setState({
        calendarList: res.data.filter((v) => v.acs_id = this.props.params.acs_id),
      })

    } catch (err) {
      toast.error('Something went wrong while fetching calendar!')
      // console.log(err)
    }
  }

  /**************************************
   * Get Exams
   */
  getExams = async (limit = this.state.examsData.limit, offset = 0) => {
    const { authData, params } = this.props;
    const { auth_key } = authData.loginData;
    const { center_id } = authData.centerData;
    const { selectedChild } = this.props;
    let examsData = this.state.examsData;
    let request_params = {
      center_id,
      class_id: selectedChild.class_id,
      child_id: selectedChild.child_id,
      acs_id: params.acs_id,
      is_homework: 0,
      limit: limit,
      offset: offset,
      auth_key: auth_key,
    };

    try {
      const res = await GET('exams/get-exams-new', {
        params: request_params,
      });
      this.setState({
        examsData: { ...examsData, data: res.data.data, totalRecords: parseInt(res.data.total_count_filtered), lastPage: Math.ceil(parseInt(res.data.total_count_filtered) / limit), },
      });
    } catch (err) {
      toast.error('Something went wrong while fetching exams!');
      // console.log(err);
    }
  };
  getHomeworks = async (limit = this.state.homeworkData.limit, offset = 0) => {
    const { authData, params } = this.props;
    const { auth_key } = authData.loginData;
    const { center_id } = authData.centerData;
    const { selectedChild } = this.props;
    let homeworkData = this.state.homeworkData;
    let request_params = {
      center_id,
      class_id: selectedChild.class_id,
      child_id: selectedChild.child_id,
      acs_id: params.acs_id,
      is_homework: 1,
      limit: limit,
      offset: offset,
      auth_key: auth_key,
    };

    try {
      const res = await GET('exams/get-exams-new', {
        params: request_params,
      });
      this.setState({
        homeworkData: {
          ...homeworkData, data: res.data.data, totalRecords: parseInt(res.data.total_count_filtered), lastPage: Math.ceil(parseInt(res.data.total_count_filtered) / limit),
        },
      });
    } catch (err) {
      toast.error('Something went wrong while fetching exams!');
      // console.log(err);
    }
  };


  /**************************************************
   * Get Lessons
   */
  getLessons = async (limit = this.state.limit, offset = 0) => {
    const { authData, params } = this.props;
    const { auth_key } = authData.loginData;
    const { center_id } = authData.centerData;
    const { selectedChild } = this.props;
    let request_params = {
      center_id,
      acs_id: params.acs_id,
      limit,
      offset,
      auth_key: auth_key,
      class_id: this.props.selectedChild.class_id,
      order: 'timetable_lessons.activation_date',
      dir: 'DESC'
    };

    try {
      const res = await GET('academic-subject-lessons/get',
        {
          params: request_params,
        }
      );

      const { limit } = this.state;

      this.setState({
        lessons: res.data.data,
        totalRecords: parseInt(res.data.total_count),
        lastPage: Math.ceil(parseInt(res.data.total_count) / limit),
      });
    } catch (err) {
      toast.error('Something went wrong while fetching lessons!');
      // console.log(err);
    }
  };

  /**
   * Get Today's Lessons
   */
  getTodaysLessons = async () => {
    const { authData, params } = this.props;
    const { auth_key } = authData.loginData;
    const { center_id } = authData.centerData;
    const { selectedChild } = this.props;
    let request_params = {
      center_id,
      class_id: selectedChild.class_id,
      class_theme: selectedChild.class_theme,
      material_id: params.material_id,
      auth_key: auth_key,
    };

    try {
      const req = await GET('dashboard/get-active-lesson-single',
        {
          params: request_params,
        }
      );

      this.setState({
        todaysLessons: req.data.data,
      });
    } catch (err) {
      toast.error("Something went wrong while fetching today's lessons!");
      // console.log(err);
    }
  };

  /**
   * Render Component
   * @returns {HTMLElement}
   */
  render() {
    const { examsData, lessons, todaysLessons, limit, totalRecords, homeworkData, getAcademicClassmainSubjectData, examModalInfo, searchLesson, activitiesData } = this.state;

    return (
      <Container fluid>
        <div id='iedu-layout'>
          <NavBar />
          <div id='page-content'>
            <Header lite={true} heading={getAcademicClassmainSubjectData?.acs_name} backBtn={true} />
            <div className='grey-section p-3'>
              <div className='d-flex flex-row' style={{ fontSize: 12 }}>
                {/* LEFT */}
                <div style={{ width: '70%', minHeight: '81vh', height: '81vh', borderRight: 'solid 1px ' + WhiteMarble, overflowY: 'auto' }} className='d-flex flex-column pe-2 me-2'>
                  {/* TASKS */}
                  <div style={{ width: '100%' }}>
                    <Card className='p-0' style={{ borderRadius: 25, borderWidth: 0, minHeight: 50, fontSize: 12 }} >
                      <Card.Body className='p-2 overflow-hidden position-relative' >
                        <div className='d-flex flex-row align-items-center justify-content-between mb-2'>
                          <div className="px-2" style={{ fontWeight: 'bold', fontSize: 14 }}>Tasks</div>
                          <div className="px-2 d-flex flex-row align-items-center">
                            <div style={{ backgroundColor: WhiteMarble, color: Black, padding: '5px 10px', borderRadius: 5, fontSize: 11 }} className='d-flex flex-row align-items-center me-2'>
                              <GetIcon icon={'LuCalendar1'} className={'me-1'} style={{ fontSize: 14 }} />
                              {moment().format('dddd, DD MMM YYYY')}
                            </div>
                            <div>
                              <Link to='/calendar' style={{ textDecoration: 'none' }}>
                                <GetIcon icon="LuExternalLink" style={{ color: BlueCrayola }} />
                              </Link>
                            </div>
                          </div>
                        </div>
                        <div className='grey-section mb-0 p-1' style={{ minHeight: '20vh', borderRadius: 5, }}>
                          {!this.state.calendarList &&
                            <div style={{ textAlign: 'center' }}>
                              <Spinner animation="grow" />
                            </div>
                          }
                          {this.state.calendarList?.length == 0 &&
                            <div style={{ textAlign: 'center' }}>
                              {t('No Data Found!')}
                            </div>
                          }
                          {this.state.calendarList?.length > 0 && this.state.calendarList.map((item, index) => {
                            const body = (item.body) ? item.body.replace(/(<([^>]+)>)/gi, "") : item.body
                            // console.log('item', item);

                            return (
                              <div key={index} style={{ backgroundColor: White, borderRadius: 5, borderLeft: 'solid 2px ' + BlueCrayola, fontSize: 11 }} className='px-2 py-1 d-flex flex-row justify-content-between align-items-center mb-2'>
                                <div>
                                  {item.title}
                                  {/* - {(body && body.length > 50) ? body.substring(0, 50) + '...' : body} */}
                                </div>
                                <div className='d-flex flex-row align-items-center'>
                                  <div style={{ color: Purple, padding: '3px 6px', borderRadius: 5, border: 'solid 1px ' + Purple }} className='d-flex flex-row align-items-center me-2'>
                                    {item.add_type.toUpperCase()}
                                  </div>
                                  <div style={{ backgroundColor: CyanProcess, color: White, padding: '3px 6px', borderRadius: 5 }} className='d-flex flex-row align-items-center me-2'>
                                    {item.acs_name}
                                  </div>
                                  <div>
                                    <Link to='/calendar' style={{ textDecoration: 'none' }}>
                                      <GetIcon icon="LuExternalLink" style={{ color: BlueCrayola }} />
                                    </Link>
                                  </div>
                                </div>
                              </div>
                            )
                          })}
                        </div>
                      </Card.Body>
                    </Card>
                  </div>
                  {/* EXAMS */}
                  <div style={{ backgroundColor: White, width: '100%', borderRadius: 25 }} className='p-2 mt-2'>
                    <div className='mx-2' style={{ fontWeight: 'bold', fontSize: 14 }}>Exams</div>
                    <div className='d-flex flex-row flex-wrap'>
                      {examsData.data.map((v, index) => {
                        let is_homework = 0
                        let data = {
                          allData: v,
                          name: v.exams_name,
                          code: (v.is_exampaper == 1) ? t('Paper') : t('Online'),
                          text1: v.examstype_name,
                          description: v.exams_notes,
                          cardImage: null,
                          extraTexts: [],
                          actions: []
                        }
                        // console.log('moment()', moment().format('DD-MM-YYYY'), moment(v.exams_date + ' ' + v.open_time).format('DD-MM-YYYY'));

                        if (v.is_exampaper) {
                          data.actions.push({ text: 'Offline', backgroundColor: ColonialWhite, textColor: PaleOyster, iconName: 'LuCloudOff', onClick: () => examModalInfo.toggle(v) })
                        } else {
                          if ((moment().isSameOrAfter(moment(v.exams_date + ' ' + v.open_time)) && moment().isSameOrBefore(moment(v.exams_date + ' ' + v.close_time)))) {
                            data.actions.push({ text: 'Start Attempt', backgroundColor: CyanProcess, textColor: White, iconName: 'FaPlay', onClick: () => examModalInfo.toggle(v) })
                          } else {
                            data.actions.push({ text: 'Start Attempt', backgroundColor: LightSilver, textColor: White, iconName: 'LuCloudOff' })
                          }
                        }

                        if (v.exams_attachment) {
                          data.extraTexts.push({ text: (v.exams_attachment.includes(".pdf")) ? 'Attached PDF' : t('Attached Image'), onClick: () => { window.open(getRegionalStorageURL() + this.props.authData.centerData.center_uuid + '/exams/' + v.exams_attachment, '_blank') }, iconName: 'LuLink2', textColor: CyanProcess })
                        }
                        let examDateTime = moment(v.exams_date + ' ' + v.open_time).format('DD-MM-YYYY HH:mm')
                        if (v.close_time) {
                          examDateTime += ' - ' + v.close_time

                        }
                        if (v.examsgrade && this.props.authData.userData.parent_status == 1) {
                          data.extraTexts.push({ text: (v.examsgrade.absence_id) ? 'Marked Absent: ' + v.examsgrade.absence_name : 'Graded: ' + v.examsgrade.examsgrade_grade + '/' + v.examsgrade.examsgrade_totalgrade, onClick: () => { }, iconName: 'LuBookCheck', textColor: VividMalachite })
                        }
                        data.extraTexts.push({ text: examDateTime, textColor: Argent, iconName: 'LuCalendar', onClick: () => { } })
                        return <ExamsCard data={data} key={index} cardWidth='33.33' />
                      }
                      )}
                    </div>
                    <Paginate limit={examsData.limit} totalRecords={examsData.totalRecords} pageChange={this.getExams} />
                  </div>
                  {/* HOMEWORK */}
                  <div style={{ backgroundColor: White, width: '100%', borderRadius: 25 }} className='p-2 mt-2'>
                    <div className='mx-2' style={{ fontWeight: 'bold', fontSize: 14 }}>Homework</div>
                    <div className='d-flex flex-row flex-wrap'>
                      {homeworkData.data.map((v, index) => {
                        let is_homework = 1
                        let data = {
                          allData: v,
                          name: v.exams_name,
                          code: (v.is_exampaper == 1) ? t('Paper') : t('Online'),
                          text1: v.examstype_name,
                          description: v.exams_notes,
                          cardImage: null,
                          extraTexts: [],
                          actions: []
                        }

                        if (v.is_exampaper) {
                          data.actions.push({ text: 'Offline', backgroundColor: ColonialWhite, textColor: PaleOyster, iconName: 'LuCloudOff', onClick: () => examModalInfo.toggle(v) })
                        } else {
                          if ((moment().isSameOrAfter(moment(v.exams_date + ' ' + v.open_time)) && moment().isSameOrBefore(moment(v.due_date + ' ' + v.close_time)))) {
                            data.actions.push({ text: 'Start Attempt', backgroundColor: CyanProcess, textColor: White, iconName: 'FaPlay', onClick: () => examModalInfo.toggle(v) })
                          } else {
                            data.actions.push({ text: 'Start Attempt', backgroundColor: LightSilver, textColor: White, iconName: 'LuCloudOff' })
                          }
                        }

                        if (v.exams_attachment) {
                          data.extraTexts.push({ text: (v.exams_attachment.includes(".pdf")) ? 'Attached PDF' : t('Attached Image'), onClick: () => { window.open(getRegionalStorageURL() + this.props.authData.centerData.center_uuid + '/exams/' + v.exams_attachment, '_blank') }, iconName: 'LuLink2', textColor: CyanProcess })
                        }
                        let examDateTime = moment(v.exams_date + ' ' + v.open_time).format('DD-MM-YYYY HH:mm')
                        if (is_homework) {
                          examDateTime += ' - ' + moment(v.due_date + ' ' + v.close_time).format('DD-MM-YYYY HH:mm')
                        } else if (v.close_time) {
                          examDateTime += ' - ' + v.close_time

                        }
                        if (v.examsgrade && this.props.authData.userData.parent_status == 1) {
                          data.extraTexts.push({ text: (v.examsgrade.absence_id) ? 'Marked Absent: ' + v.examsgrade.absence_name : 'Graded: ' + v.examsgrade.examsgrade_grade + '/' + v.examsgrade.examsgrade_totalgrade, onClick: () => { }, iconName: 'LuBookCheck', textColor: VividMalachite })
                        }
                        data.extraTexts.push({ text: examDateTime, textColor: Argent, iconName: 'LuCalendar', onClick: () => { } })
                        return <ExamsCard data={data} key={index} cardWidth='33.33' />
                      }
                      )}
                    </div>
                    <Paginate limit={homeworkData.limit} totalRecords={homeworkData.totalRecords} pageChange={this.getHomeworks} />
                  </div>
                  {/* CLASS ACTIVITIES */}
                  <div style={{ backgroundColor: White, width: '100%', borderRadius: 25 }} className='p-2 mt-2'>
                    <div className='mx-2' style={{ fontWeight: 'bold', fontSize: 14 }}>Class Activities</div>
                    <div className='d-flex flex-row flex-wrap'>
                      {activitiesData.data.length > 0 ? (
                        <div className='d-flex flex-row flex-wrap p-1'>
                          {activitiesData.data.map((v, index) => {

                            return this.renderActivities(v)
                          }
                          )}
                        </div>
                      ) : (
                        null
                      )}
                    </div>
                  </div>
                </div>
                {/* RIGHT */}
                <div style={{ width: '30%', minHeight: '81vh', height: '81vh' }} className='d-flex position-relative'>
                  {/* LESSONS */}
                  <div style={{ backgroundColor: White, width: '100%', borderRadius: 25 }} className='p-2'>
                    <div className='d-flex flex-row align-items-center'>
                      <div style={{ width: '30%', fontWeight: 'bold', fontSize: 14 }} className='text-center'>All Lessons</div>
                      <div style={{ width: '70%' }} className='px-1 mb-2 position-relative'>
                        <Form.Control type='text' placeholder={t('SEARCH LESSON...')} style={{ borderRadius: 50, padding: '5px 15px', fontSize: 12 }} value={searchLesson} onChange={(e) => this.setState({ searchLesson: e.target.value })} />
                        <div style={{ position: 'absolute', top: 5, right: 30 }}>
                          <GetIcon icon="LuSearch" style={{ color: BlueCrayola }} />
                        </div>
                      </div>
                    </div>
                    {lessons && lessons.map((aslData_v, aslData_i) => {
                      if (!aslData_v.asl_name.toLowerCase().includes(searchLesson.toLowerCase()) && !aslData_v.asl_code.toLowerCase().includes(searchLesson.toLowerCase())) {
                        return null
                      }
                      return <div style={{ border: 'solid 1px ' + WhiteMarble, borderRadius: 10, width: '100%' }} className='d-flex flex-row align-items-center p-2 cursor-pointer my-2'>
                        <div style={{ borderRight: 'solid 1px ' + WhiteMarble }} className='pe-1 me-1'>
                          <Image src={(aslData_v.asl_attach) ? getRegionalStorageURL() + this.props.authData.centerData.center_uuid + '/academic_subject_lessons/' + aslData_v.asl_attach : require('../../assets/images/noimage.png')} style={{ objectFit: 'contain', width: '70px', height: '100%', borderRadius: 5 }} />
                        </div>
                        <div className='ms-1' style={{ flex: 1 }}>
                          <div style={{ fontSize: 10, color: RedLustre }}>{aslData_v.asl_code}</div>
                          <div style={{ fontWeight: '600' }}>{aslData_v.asl_name}</div>
                          <div className='d-flex flex-row align-items-center' style={{ color: SpanishGray }}>
                            <GetIcon icon="LuCalendar" className={'me-1'} />
                            <div style={{ fontSize: 10 }}>{moment(aslData_v.activation_date).format('DD-MM-YYYY')}</div>
                          </div>
                          {aslData_v.acs_id != this.props.params.acs_id &&
                            <div className='d-flex flex-row align-items-center' style={{ color: SpanishGray }}>
                              <GetIcon icon="LuBook" className={'me-1'} />
                              <div style={{ fontSize: 10 }}>{aslData_v.acs_name}</div>
                            </div>
                          }
                        </div>
                        <div className='ms-1'>
                          <Link to={'/lesson-details/' + aslData_v.asl_id} state={{ lessonData: aslData_v }} style={{ textDecoration: 'none' }}  >
                            <GetIcon icon="LuExternalLink" style={{ color: BlueCrayola }} />
                          </Link>
                        </div>
                      </div>
                    })}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Modal backdrop='static' keyboard={false} fullscreen show={examModalInfo.show} onHide={examModalInfo.toggle}>
          <Modal.Header closeButton>
            <div className='w-100 d-flex flex-row justify-content-between'>
              <div style={{ flex: 1 }}>
                <Modal.Title style={{ fontSize: 20 }}>
                  {examModalInfo.data?.exams_name}
                </Modal.Title>
              </div>
            </div>
          </Modal.Header>
          {examModalInfo.show &&
            <Modal.Body className='p-0 overflow-hidden'>
              <div className='d-flex flex-row' style={{ fontSize: 12 }}>
                {/* LEFT */}
                <div style={{ width: '70%', minHeight: '85vh', height: '85vh', borderRight: 'solid 1px ' + WhiteMarble }} className='d-flex flex-column ps-3 pe-2'>
                  <div className='d-flex flex-row align-items-center'>
                    <div>
                      <Image src={(examModalInfo.data.acs_image) ? getRegionalStorageURL() + this.props.authData.centerData.center_uuid + '/academic_classmain_subject/' + examModalInfo.data.acs_image : require('../../assets/images/noimage.png')} style={{ objectFit: 'contain', width: '100%', height: '9.5rem', backgroundColor: White, borderRadius: '1rem' }} />
                    </div>
                    <div className='d-flex flex-column'>
                      {/* due_date */}
                      <div style={{ fontWeight: 'bold', fontSize: 14 }} className='mb-1'>{examModalInfo.data.exams_name}</div>
                      <div className='d-flex flex-row align-items-center mb-1' style={{ color: SpanishGray }}>
                        <GetIcon icon="LuCalendar1" />
                        <div className='mx-2'>{moment(examModalInfo.data.exams_date).format('DD-MM-YYYY')}</div>
                        <div>{examModalInfo.data.open_time}</div>
                        <div>-</div>
                        <div>{examModalInfo.data.close_time}</div>
                      </div>
                      <div className='d-flex flex-row align-items-center mb-1'>
                        <div style={{ backgroundColor: CyanProcess, color: White, padding: '2px 4px', borderRadius: 5, fontSize: 11 }} className='d-flex flex-row align-items-center'>
                          {examModalInfo.data.acs_name}
                        </div>
                        <div style={{ backgroundColor: CerisePink, color: White, padding: '2px 4px', borderRadius: 5, fontSize: 11 }} className='d-flex flex-row align-items-center ms-2'>
                          {examModalInfo.data.examstype_name}
                        </div>
                      </div>
                    </div>
                  </div>
                  {examModalInfo.data.exams_notes &&
                    <div className='mt-2'>
                      <div style={{ fontWeight: '600' }}>Description</div>
                      <div>{examModalInfo.data.exams_notes}</div>
                    </div>
                  }
                  {examModalInfo.data.exams_attachment &&
                    <div className='d-flex flex-column align-items-start mt-2'>
                      <div style={{ fontWeight: '600' }}>Attachment</div>
                      <div style={{ border: 'solid 1px ' + WhiteMarble, borderRadius: 10 }} className='d-flex flex-row align-items-center p-2 cursor-pointer' onClick={() => window.open(getRegionalStorageURL() + this.props.authData.centerData.center_uuid + '/exams/' + examModalInfo.data.exams_attachment, '_blank')}>
                        <GetIcon icon={(examModalInfo.data.exams_attachment.includes(".pdf")) ? 'PiFilePdfFill' : 'PiFileImageFill'} style={{ fontSize: 20, color: examModalInfo.data.exams_attachment.includes(".pdf") ? RedLustre : AmericanGreen }} />
                        <div className='ms-1'>{(examModalInfo.data.exams_attachment.includes(".pdf")) ? 'Attached PDF' : t('Attached Image')}</div>
                      </div>
                    </div>
                  }
                </div>
                {/* RIGHT */}
                <div style={{ width: '30%', minHeight: '85vh', height: '85vh' }} className='d-flex position-relative'>
                  <div className='px-2' style={{ width: '100%' }}>
                    {examModalInfo.data?.aslData && examModalInfo.data?.aslData.map((aslData_v, aslData_i) => {
                      return <div style={{ border: 'solid 1px ' + WhiteMarble, borderRadius: 10, width: '100%' }} className='d-flex flex-row align-items-center p-2 cursor-pointer my-2'>
                        <div style={{ borderRight: 'solid 1px ' + WhiteMarble }} className='pe-1 me-1'>
                          <Image src={(aslData_v.asl_attach) ? getRegionalStorageURL() + this.props.authData.centerData.center_uuid + '/academic_subject_lessons/' + aslData_v.asl_attach : require('../../assets/images/noimage.png')} style={{ objectFit: 'contain', width: '70px', height: '100%', borderRadius: 5 }} />
                        </div>
                        <div className='ms-1' style={{ flex: 1 }}>
                          <div style={{ fontSize: 10, color: RedLustre }}>{aslData_v.asl_code}</div>
                          <div style={{ fontWeight: '600' }}>{aslData_v.asl_name}</div>
                        </div>
                        <div className='ms-1'>
                          <Link to={'/lesson-details/' + aslData_v.asl_id} state={{ lessonData: aslData_v }} style={{ textDecoration: 'none' }}  >
                            <GetIcon icon="LuExternalLink" style={{ color: BlueCrayola }} />
                          </Link>
                        </div>
                      </div>
                    })}
                  </div>
                </div>
              </div>


            </Modal.Body>
          }
          {examModalInfo.show &&
            <Modal.Footer>
              <div className='d-flex flex-row justify-content-end align-items-center'>
                <div className='d-flex flex-row align-items-center justify-content-center cursor-pointer p-2 mb-2' style={{ borderRadius: '0.5rem', backgroundColor: CerisePink, color: White }} onClick={() => examModalInfo.toggle()} >
                  <div className='ms-1'>{t('Close')}</div>
                </div>
                {!examModalInfo.data.is_exampaper &&
                  <Link to={'/attempt-exam/' + examModalInfo.data.exams_id + '/' + (examModalInfo.data.exam_retake_id ? examModalInfo.data.exam_retake_id : 0) + '/' + this.props.is_homework} style={{ textDecoration: 'none' }}>
                    <div className='d-flex flex-row align-items-center justify-content-center cursor-pointer p-2 mb-2 mx-3' style={{ borderRadius: '0.5rem', backgroundColor: CyanProcess, color: White }}  >
                      <GetIcon icon={'FaPlay'} />
                      <div className='ms-1'>{t('Start Attempt')}</div>
                    </div>
                  </Link>
                }
              </div>
            </Modal.Footer>
          }
        </Modal>

        {/* ACADEMIC ACTIVITY REFLECTION MODAL */}
        <AcademicActivityReflection academicActivityReflectionModal={this.state.academicActivityReflectionModal} />
      </Container >
    );
  }
}

const mapStateToProps = (state) => ({
  authData: state.auth.authData,
  selectedChild: state.selectedChild.data,
  languages: state.language.languages,
  defaultLanguage: state.language.defaultLanguage,
});

export default connect(mapStateToProps, null)(withParams(Subject));
